import { Output, EventEmitter, ViewChild, } from '@angular/core';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { GraphqlService } from 'src/app/common/services/graphql.service';
import { ValidationService } from 'src/app/common/services/validation.service';
import { constObj } from '../../Constants/constants';
import { MatSelect } from '@angular/material/select';
import { SessionService } from '../../services/Session.service';
import { LoginService } from '../../services/Login.service';


@Component({
  selector: 'app-general-feedback',
  templateUrl: './general-feedback.component.html',
  styleUrls: ['./general-feedback.component.css']
})
export class GeneralFeedbackComponent implements OnInit {

  @Output() myEvent = new EventEmitter<string>();
  loadpagecontent: boolean = false;
  globalcancel: string;
  generalFeedbacklink: string;
  generalFeedbacktext: string;
  providefeedback: string;
  yourfeedback: string;
  globalsubmit: string;
  typeoffeedback: string;
  feedbackTypeList: string[];
  param: {};
  textareaError: string = "";
  usernameError;
  usernameInput: any;
  feedbackvalidationError: string;
  feedbackTypeValidationError: string;
  feedbackEmailbody: string;
  feedbackEmailsubject: string;
  emailsubjectcodtech: string;
  emailbodycodtech: string;

  constructor(
    public commonDataService: CommonDataService,
    private graphQlService: GraphqlService,
    private validationService: ValidationService,
    private loginService: LoginService,
    private session: SessionService
  ) {
  }

  currentParagraph: string;
  navData = {
    crumbData: [],
  };  


  feedBackForm = new FormGroup({
    feedBackEmail: new FormControl(''),
    feedBackEmailVerify: new FormControl(''),
    feedBackType: new FormControl(''),
    feedBackContent: new FormControl(''),
    emailMismatch: new FormControl('')
  })

  @ViewChild("feedBackTypeSelect", { static: false }) nameField: MatSelect;
  userRole: string = "";
  userinfo;
  ngOnInit(): void {
    this.commonDataService.showLoader.next(true);
    if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
      this.loginService.getSession().subscribe(data => {
        this.userRole = data.user.roles;
        this.userinfo = data.user;
        this.session.assignUserInfo(data.user);
      })
    }
    else {
      this.userRole = this.session.userInfo.user.roles;
      this.userinfo = this.session.userInfo.user;
    }
    this.getProfessionalContent();
    this.getgeneralFeedbackDropdownValues();    
  }
  
  public hasError = (controlName: string, errorName: string) => {
    return this.feedBackForm.controls[controlName].hasError(errorName);
  }
  emailLabel: string;
  emailConfirmationLabel: string;
  getProfessionalContent() {    
    this.graphQlService.getGlobalLabels().subscribe(data => {
      if (data != null) {        
        this.loadpagecontent = true;             
        var labels = data.content.data.labels;
        labels = labels.filter(x => x.key.trim());
        this.emailLabel = labels.filter(x => x.key == "provideFeedback_enterEmail").map(y => y.value);
        this.emailConfirmationLabel = labels.filter(x => x.key == "provideFeedback_verifyEmail").map(y => y.value);
        this.providefeedback = labels.filter(x => x.key == "generalFeedback_title").map(y => y.value);
        this.typeoffeedback = labels.filter(x => x.key == "provideFeedback_title").map(y => y.value);
        this.globalcancel = labels.filter(x => x.key == "global_cancel").map(y => y.value);
        this.globalsubmit = labels.filter(x => x.key == "global_submit").map(y => y.value);
        this.yourfeedback = labels.filter(x => x.key == "provideFeedback_body").map(y => y.value);
        this.commonDataService.showLoader.next(false);
      }
      else {
        //TODO : check the negative scenario
        this.commonDataService.showLoader.next(false);
      }
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }
  enterKey() {
    this.submittFeedback();
  }

  getgeneralFeedbackDropdownValues() {    
    this.graphQlService.getgeneralFeedbackDropdown().subscribe(data => {
      if (data != null) {       
        this.loadpagecontent = true;        
        this.feedbackTypeList = data.content.data.listItem;
        this.commonDataService.showLoader.next(false);
      }      
    }, err => {
      console.log(err);
      this.commonDataService.showLoader.next(false);
    });
  }

 

  remainingText: number = 0;
  feedbackDescriptionChange(value: string) {
    this.remainingText = 4000 - value.length;
  }

  closeOverlay() {
    this.myEvent.emit();
    this.commonDataService.showLoader.next(false);
  }
  checkHome() {
  }

  checkfeedBackType() {
    let isValid = true;
    if (!this.validationService.validateRequiredField(this.feedBackForm.controls.feedBackType.value)) {
      this.feedBackForm.controls.feedBackType.setErrors({ 'isEmpty': true });
      this.feedbackTypeValidationError = this.validationService.getErrorMessage('required', this.typeoffeedback, null);
      this.feedBackForm.controls.feedBackType.markAsTouched();
      isValid = false
      }
    

    if (isValid) {
      this.feedBackForm.controls.feedBackType.setErrors(null);
      this.feedbackTypeValidationError = '';
    }

    return isValid;
  }

  checkEmailValidations() {
    let isEmailValid = this.checkEmail();
    let isVerifiedEmailValid = isEmailValid ? this.checkVerifiedEmail() : true;
    let isEmailMatchingEmailValid = this.matchEmail();

    return ((isEmailValid && isVerifiedEmailValid && isEmailMatchingEmailValid) || this.userRole != "Basic");
  }

  emailError: string;
  checkEmail(): boolean {
    let emailValid = true;
    let email = this.feedBackForm.controls.feedBackEmail;
    if (!this.validationService.validateRequiredField(email.value)) {
      email.setErrors({ 'required': true });
      this.emailError = this.emailLabel;
      email.markAsTouched();
      emailValid = false;
    }
    else if (!this.validationService.validateEmailformat(email.value) || !this.validationService.validateEmailfullformat(email.value)
      || !this.validationService.validateEmailspecialCharformat(email.value) || !this.validationService.validatemailpostionRegexformat(email.value)) {
      email.setErrors({ 'hasInvalidEmail': true });
      this.emailError = this.validationService.getErrorMessage('valid', "email address", null);
      email.markAsTouched();
      emailValid = false
    }
    if (emailValid) {
      email.setErrors(null);
    }

    return emailValid;
  }

  verifiedEmailError: string;
  emailMismatchError: string;
  checkVerifiedEmail(): boolean {
    let emailValid = true;
    let email = this.feedBackForm.controls.feedBackEmailVerify;
    if (!this.validationService.validateRequiredField(email.value)) {
      email.setErrors({ 'required': true });
      this.verifiedEmailError = this.emailConfirmationLabel;
      email.markAsTouched();
      emailValid = false;
    }
    else if (!this.validationService.validateEmailformat(email.value) || !this.validationService.validateEmailfullformat(email.value)
      || !this.validationService.validateEmailspecialCharformat(email.value) || !this.validationService.validatemailpostionRegexformat(email.value)) {
      email.setErrors({ 'hasInvalidEmail': true });
      this.verifiedEmailError = this.validationService.getErrorMessage('valid', "email address", null);
      email.markAsTouched();
      emailValid = false
    }
    if (emailValid) {
      email.setErrors(null);
    }

    return emailValid;
  }

  matchEmail(): boolean {
    let email = this.feedBackForm.controls.feedBackEmail.value;
    let emailVerify = this.feedBackForm.controls.feedBackEmailVerify.value;

    let isValid = this.validationService.compareString(email, emailVerify);

    if (!isValid) {
      this.feedBackForm.controls.emailMismatch.setErrors({ 'emailMismatch': true });
      this.emailMismatchError = "The email addresses entered do not match";
      this.feedBackForm.controls.feedBackEmail.markAsTouched();
      this.feedBackForm.controls.feedBackEmailVerify.markAsTouched();
    }
    else {
      this.feedBackForm.controls.emailMismatch.setErrors(null);
      this.emailMismatchError = null;
    }
    return isValid;
  }

  checkfeedBackContent() {
    let isfeedBackContentValid = true;
    if (!this.validationService.validateRequiredField(this.feedBackForm.controls.feedBackContent.value) || this.feedBackForm.controls.feedBackContent.value.trim() == "") {
      this.feedBackForm.controls.feedBackContent.setErrors({ 'isEmpty': true });
      this.feedbackvalidationError = this.validationService.getErrorMessage('required', this.yourfeedback, null);
      this.feedBackForm.controls.feedBackContent.markAsTouched();
      isfeedBackContentValid = false
    }


    if (isfeedBackContentValid) {
      this.feedBackForm.controls.feedBackContent.setErrors(null);
      this.feedbackvalidationError = '';
    }

    return isfeedBackContentValid;
  }

  submittFeedback() {
    let checkfeedBackTypeValid = this.checkfeedBackType();
    let checkfeedBackContentValid = this.checkfeedBackContent();
    let checkEmailValid = this.checkEmailValidations();

    if (checkfeedBackTypeValid && checkfeedBackContentValid && checkEmailValid)
    {
      //code for fetch email lables
      this.commonDataService.showLoader.next(true);
      this.graphQlService.getGlobalLabels().subscribe(data => {
        if (data != null) {            
          this.loadpagecontent = true;
          //var labels = data.labels.content.data.labels
          var labels = data.content.data.labels
          labels = labels.filter(x => x.key.trim());
          this.feedbackEmailbody = labels.filter(x => x.key == "feedbackEmail_body").map(y => y.value);
          this.feedbackEmailsubject = labels.filter(x => x.key == "feedbackEmail_subject").map(y => y.value);
          this.emailsubjectcodtech = labels.filter(x => x.key == "codtechEmail_subject").map(y => y.value);
          this.emailbodycodtech = labels.filter(x => x.key == "codtechEmail_body").map(y => y.value);
          const body = {
            userEmail: this.userRole == 'Basic' ? this.feedBackForm.controls.feedBackEmail.value : this.userinfo.email,
            feedBackContent: this.feedBackForm.controls.feedBackContent.value,
            feedBackType: this.feedBackForm.controls.feedBackType.value,
            feedbackEmailbody: this.feedbackEmailbody[0],
            feedbackEmailsubject: this.feedbackEmailsubject[0],
            emailsubjectcodtech: this.emailsubjectcodtech[0],
            emailbodycodtech: this.emailbodycodtech[0]
          };
          this.graphQlService.sentmailgeneralFeedback(body).subscribe(mailBody => {
            if (mailBody != null) {
              let obj;
              if (mailBody.isEmailSent) {
                obj = {
                  type: 'success',
                  displayTime: 5000,
                  position: 'bottom',
                  message: constObj.generalFeedbackSuccess
                }
              }
              else {
                obj = {
                  type: 'fail',
                  displayTime: 5000,
                  position: 'bottom',
                  message: constObj.generalFeedbacemailFail
                }
              }
              this.commonDataService.notificationObject.next(obj);
              this.closeOverlay();
            }
            else {
              this.closeOverlay();
            }
          }, err => {
            console.log(err);
            this.commonDataService.showLoader.next(false);
          });
        }          
      }, err => {
        console.log(err);
        this.commonDataService.showLoader.next(false);
      });
    }  
  }

}
